import mealService from '@/api/meal'
import { MEAL } from '../types'

export default {
  namespaced: true,
  state: {
    meals: []
  },
  getters: {
    meals (state) {
      return state.meals
    },
  },
  mutations: {
    [MEAL.SET_MEALS](state, meals) {
      state.meals = meals
    }
  },
  actions: {
    getMeals: function ({commit, dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        mealService.getMeals().then((response) => {
          commit(MEAL.SET_MEALS, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    async addMeal({ dispatch }, meal) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        await mealService.addMeal(meal)
        await dispatch('getMeals')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async editMeal({ dispatch }, meal) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        await mealService.editMeal(meal)
        await dispatch('getMeals')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    activateMeal: function (_, mealId) {
      return new Promise((resolve, reject) => {
        mealService.activateMeal(mealId).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    deactivateMeal: function (_, mealId) {
      return new Promise((resolve, reject) => {
        mealService.deactivateMeal(mealId).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    }
  }
}
